<template>
  <!--<div class="order" style="padding-bottom: 115px" v-touch:left="onSwipeLeft" ref="maintain" @touchstart="touchStart">-->
  <div class="order" style="padding-bottom: 115px" >
    <header>
      <div class="headerDiv" v-on:click="backHistory"  @click="">
        <img src="@/assets/img/back.png" alt="">
        <p style="color: #FFFFFF">确认订单</p>
      </div>
    </header>
    <div style="padding: 0 10px;padding-bottom: 1rem">
    <div @click="toAddress" class="orderMessage" v-if="address">
      <div class="orderIcon">
        <van-icon size="20" color="#FFFFFF" name="location" />
      </div>
      <div class="orderP">
        <div v-if="address">
          <p><span>{{address.name}}</span> {{address.tel}}</p>
          <p >{{address.province}}{{address.city}}{{address.county}}{{address.address}}</p>
        </div>
      </div>
    </div>
      <div class="orderMessage1" v-else="" @click="toAddress" ><!--无收货地址显示-->
        <div class="">
          <!--<van-icon size="20" color="#FFFFFF" name="location" />-->
          <van-icon name="add-o" size="22"  color="gray"/>
        </div>
        <div class="orderP">
          <div >
            <p><span></span>请添加收货地址</p>
          </div>
        </div>
      </div>
      <div class="orderDetail" v-for="(item,index) in list" v-if="list">
      <p class="shopIcon" >
        <span><img :src="item.merchant_logo" style="width: 20px" alt=""></span>
        <span style="display: flex">
                <span>{{item.merchant_title}}</span>
                <span><van-icon name="arrow"/></span>
        </span>
      </p>
      <div style="margin-top: 1rem" v-for="(a,b) in item.goods">
      <div class="orderDetailDiv">
        <div class="orderDetailTitle">
          <div class="orderDetailTitleImg">
            <!--<img src="https://img.yzcdn.cn/vant/apple-1.jpg" alt="">-->
            <img :src="a.img" alt="">
          </div>
        <div class="orderDetailMessage">
          <p>{{a.title}}</p>
          <div>
            <p>{{a.goods_spec.value}}</p>
            <p style="color:#f56723 ">发货时间：付款后48小时内</p>
          </div>
        </div>
      </div>
      <div class="orderDetailQ">￥{{a.goods_spec.price}}</div>
      </div>
      <div class="orderDetailBottom">
        <div class="productType">
          <p @click=""><span class="productg">配送方式</span><span class="productx">普通配送</span></p>
          <!--<p class="productPrice"><span class="productImg"></span></p>-->
          <p>快递 免邮<span class="productImg"></span></p>
        </div>
        <div class="productType">
          <!--<p @click=""><span class="productg">店铺优惠</span></p>-->
          <!--<p><span class="productImg"></span></p>-->
        </div>
        <div class="productType">
          <p @click=""><span class="productg">订单备注</span><span class="productx">选填，请先和商家协商一致</span></p>
        </div>
        <div class="orderTotal">
          <p @click=""><span class="productx">共{{a.stock}}件&nbsp;&nbsp;</span><span>小计：</span><span style="color: #f56723">￥{{toDecimal(a.goods_spec.total_price)}}</span></p>
        </div>
      </div>
        <van-divider dashed size="20px"  hairline="false" style="border-width: 2px 0 0"></van-divider>
      </div>
    </div>
      <!--立即购买-->
      <div  class="orderDetail"  v-if="Object.keys(this.listData).length!=0">
        <p class="shopIcon" >
          <span><img :src="listData.merchant_logo" style="width: 20px" alt=""></span>
          <span style="display: flex">
                <span>{{listData.merchant_title}}</span>
                <span><van-icon name="arrow"/></span>
        </span>
        </p>
        <div style="margin-top: 1rem" >
          <div class="orderDetailDiv">
            <div class="orderDetailTitle">
              <div class="orderDetailTitleImg">
                <!--<img src="https://img.yzcdn.cn/vant/apple-1.jpg" alt="">-->
                <img :src="goods.img" alt="">
              </div>
              <div class="orderDetailMessage">
                <p>{{goods.title}}</p>
                <div>
                  <p>{{goods.goods_spec.value}}</p>
                  <p style="color:#f56723 ">发货时间：付款后48小时内</p>
                </div>
              </div>
            </div>
            <div class="orderDetailQ" v-if="collageNum==1">￥{{goods.goods_spec.group_price}}</div>
            <div class="orderDetailQ" v-else="">￥{{goods.goods_spec.price}}</div>
          </div>
          <div class="orderDetailBottom">
            <div class="productType">
              <p @click=""><span class="productg">配送方式</span><span class="productx">普通配送</span></p>
              <p>快递 免邮<span class="productImg"></span></p>
            </div>
            <!--<div class="productType">-->
              <!--<p @click=""><span class="productg">店铺优惠</span></p>-->
              <!--<p><span class="productImg"></span></p>-->
            <!--</div>-->
            <div class="productType">
              <p @click=""><span class="productg">订单备注</span><span class="productx">选填，请先和商家协商一致</span></p>
            </div>
            <div class="orderTotal">
              <p @click=""><span class="productx">共{{goods.goods_spec.stock}}件&nbsp;&nbsp;</span><span>小计：</span><span style="color: #f56723">￥{{toDecimal(goods.goods_spec.total_price)}}</span></p>
            </div>
          </div>
          <van-divider dashed size="20px"  hairline="false" style="border-width: 2px 0 0"></van-divider>
        </div>
      </div>
      <!--赠品-->
      <div  class="orderDetail"  v-if="toDecimal(reverPrice)>200">
        <p class="shopIcon" >
          <!--<span><img :src="listData.merchant_logo" style="width: 20px" alt=""></span>-->
          <span style="display: flex">
                <span>赠品</span>
                <span><van-icon name="arrow"/></span>
        </span>
        </p>
        <div style="margin-top: 1rem" >
          <div class="orderDetailDiv">
            <div class="orderDetailTitle">
              <div class="orderDetailTitleImg">
                <!--<img src="https://img.yzcdn.cn/vant/apple-1.jpg" alt="">-->
                <img src="https://image.shangshebao.com/shop/618a3f9acea0d.jpg" alt="">
              </div>
              <div class="orderDetailMessage">
                <p>福临门自然香五常香米2kg</p>
                <div>
                  <p>{{goods.goods_spec.value}}</p>
                  <p style="color:#f56723 ">发货时间：付款后48小时内</p>
                </div>
              </div>
            </div>
            <div class="orderDetailQ" v-if="collageNum==1">￥{{goods.goods_spec.group_price}}</div>
            <!--<div class="orderDetailQ" v-else="">￥{{goods.goods_spec.price}}</div>-->
          </div>
          <div class="orderDetailBottom">
            <div class="productType">
              <p @click=""><span class="productg">配送方式</span><span class="productx">普通配送</span></p>
              <p>快递 免邮<span class="productImg"></span></p>
            </div>
            <!--<div class="productType">-->
            <!--<p @click=""><span class="productg">店铺优惠</span></p>-->
            <!--<p><span class="productImg"></span></p>-->
            <!--</div>-->
            <div class="productType">
              <p @click=""><span class="productg">订单备注</span><span class="productx">选填，请先和商家协商一致</span></p>
            </div>
            <div class="orderTotal">
              <p @click=""><span class="productx">共{{goods.goods_spec.stock}}件&nbsp;&nbsp;</span><span>小计：</span><span style="color: #f56723">￥0</span></p>
            </div>
          </div>
          <van-divider dashed size="20px"  hairline="false" style="border-width: 2px 0 0"></van-divider>
        </div>
      </div>
      <!--优惠卷-->
      <div class="cardDivList">
        <div class="cardDiv">
          <p><span class="productg">商品金额</span></p>
          <p><span class="" style="padding-right: 10px">￥{{toDecimal(allPrice)}}</span></p>
        </div>
        <div class="cardDiv">
          <!--<p><span class="productg">优惠卷</span></p>-->
          <!--<p><span class="productImg">2张</span></p>-->
           <van-coupon-cell
            :coupons="cardList"
            :chosen-coupon="chosenCoupon"
            @click="showList = true"
            show-exchange-bar="false"
            exchange-button-disabled="false"
            show-close-button="false"
          />
        </div>
      </div>
    </div>
    <!--//立即购买-->

    <!-- 优惠券列表 -->
    <van-popup
      v-model="showList"
      show-exchange-bar="false"
      round
      position="bottom"
      style="height: 90%; padding-top: 4px;"

    >
      <van-coupon-list
        :coupons="cardList"
        :chosen-coupon="chosenCoupon"
        @change="onChange"
        @exchange="onExchange"
        :disabled-coupons="disabledCoupons"



      />
    </van-popup>
    <!--<van-submit-bar :price="3050"  button-text="提交订单" >-->
      <!--<p>共计</p>-->
    <!--</van-submit-bar>-->
    <!--<van-submit-bar :price="3050" button-text="提交订单" @submit="onSubmit">-->
      <!--<van-checkbox v-model="checked">全选</van-checkbox>-->
      <!--<template #tip>-->
        <!--你的收货地址不支持同城送, <span @click="onClickEditAddress">修改地址</span>-->
      <!--</template>-->
    <!--</van-submit-bar>-->
    <!--<van-submit-bar :price="3050"   />-->
    <van-submit-bar  button-text="确认订单" @submit="insertOrder" button-color="linear-gradient(to right,#ffd01e,#ee0a24)">
      <template #default>
        <!--你的收货地址不支持同城送, <span @click="onClickEditAddress">修改地址</span>-->
        <p class="orderBottom"> <span style="color: #dedede">共{{allCount}}件</span>
          <span style="font-size: 16px">合计:</span>
          <!--<span style="color: #f56723">￥{{toDecimal(allPrice)}}</span>-->
          <span style="color: #f56723">￥{{toDecimal(reverPrice)}}</span>
        </p>
        <!--<button class="button">提交订单</button>-->
      </template>
    </van-submit-bar>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { Swipe, SwipeItem } from 'vant';

  Vue.use(Swipe);
  Vue.use(SwipeItem);
  //  import Vue from 'vue';
  import { Lazyload } from 'vant'
  Vue.use(Lazyload);
  const coupon = {
    available: 1,
    condition: '无使用门槛\n最多优惠12元',
    reason: '',
    value: 150,
    name: '优惠券名称',
    startAt: 1489104000,
    endAt: 1514592000,
    valueDesc: '1.5',
    unitDesc: '元',
  };

  export default {
    name: 'message',
    data () {
      return {
        msg: '',
        list:[],
        listData:{
//          "goods":{"goods_spec":{}}
          },
        goods:{"goods_spec":{},img:""},
        address:{},

        coupons: [{
          available: 1,
          condition: '无使用门槛\n最多优惠12元',
          reason: '',
          value: "10.00",
          name: '优惠券名称',
          startAt: 1489104000,
          endAt: 1514592000,
          valueDesc: '10',
          unitDesc: '元',
        },
          {
            available: 1,
            condition: '无使用门槛\n最多优惠12元',
            reason: '',
//            value: 150,
            name: '优惠券名称',
            startAt: 1489104000,
            endAt: 1514592000,
//            valueDesc: '1.5',
            unitDesc: '元',
          }],
        chosenCoupon: -1,//优惠券索引
        couponsList:0,//优惠券金额
        couponid:"",//优惠券id
        disabledCoupons: [],
        showList:false,
        cardList:[],
        disabledList:[],
        allPrice:0,
        startX:0,
        collageNum:""//是否平团isgroup
      }
    },
    created(){
      if(window.history&&window.history.pushState){
        history.pushState(null,null,document.URl)
        window.addEventListener("popstate",this.goBack,false)
      }
    },
    destroyed(){
      window.removeEventListener("popstate",this.goBack,false)
    },
    computed:{
      reverPrice:function () {
        return this.allPrice-this.couponsList
      }
    },
//    beforeRouteLeave(to,from,next){
//      console.log(to,from)
//    },
    methods: {
      backHistory(){
        this.$router.replace("/newShop")
//        alert(1)
        localStorage.removeItem("sendId")
      },
      onSwipeLeft () {
//        this.$router.go(-1)
//        this.$router.push("/newShop")
//        alert(1)
      },


//    },
       touchStart(e){
//        e.preventDefault()
         if(e.touches.length==1){
          this.startX=e.touches[0].clientX
         }
       },
      touchEnd(e){
        if(e.changedTouches.length==1){
          let endX=e.changedTouches[0].clientX
          this.disX=endX-this.startX;

          if(this.disX<0&&Math.abs(this.disX)>10){
//            alert(1)
            this.$router.push("/newShop")
              if(this.selectTabIndex<4&& this.questionIndex==this.questionsList[this.selectTabIndex].length-1){
                this.questionIndex=0;
                this.selectTabIndex=this.selectTabIndex+1
              }
          }else if(this.disX>0&&Math.abs(this.disX)>10){
//            alert(2)
          }
        }
      },
      touch(e){

        var router = this.$router;
        this.$refs.maintain.addEventListener('touchstart', (e) => {
          this.startX =  e.touches[0].pageX;
        })
        this.$refs.maintain.addEventListener('touchmove', (e) => {
          var moveEndX = e.changedTouches[0].pageX;
          var  X = moveEndX - this.startX;
//          this.$refs.maintain.style.position='relative';
          if ( X < -50 ) {//左滑
            this.$router.push("/newShop")
//            this.$refs.maintain.style.left=X+'px';
          }if(X>50){//右滑
//            this.$refs.maintain.style.left=X-50+'px';
          }
        })
//        this.$refs.maintain.addEventListener('touchend', (e) => {
//          console.log(this.$refs.maintain.offsetLeft)
//          if ( this.$refs.maintain.offsetLeft < -50) {
////            router.push('./newShop')
//            this.$router.push("/newShop")
//
//          }
//          if(this.$refs.maintain.offsetLeft > 50){
////            router.push('./equip')
//            this.$router.push("/newShop")
//          }
//          else{
//            this.$refs.maintain.style.left=0+'px';
//          }
//        })

      },
      toAddress(){
//        console.log(this.$route.query)
        this.$router.replace({
          path:"/harvestAddress",
          query:{
            id:this.$route.query.id,
            goodid:this.$route.query.goodid,
            spec_id:this.$route.query.spec_id,
            stock:this.$route.query.stock,
            ref:this.$route.query.ref,
          }
        })
        localStorage.setItem("sendId",this.$route.query.id)
      },
      toDecimal(x) {
        var f = parseFloat(x);
        if (isNaN(f)) {
          return false;
        }
        var f = Math.round(x*100)/100;
        var s = f.toString();

        var rs = s.indexOf('.');
        if (rs < 0) {
          rs = s.length;
          s += '.';
        }
        while (s.length <= rs + 2) {
          s += '0';
        }
        return s;
      },
      onChange(index) {
        this.showList = false;
        this.chosenCoupon = index;
        if(index!=-1){
          this.couponsList=this.cardList[index].valueDesc
        this.couponid=this.cardList[index].available
        }else {
          this.couponsList=0
        }
//        this.couponsList=this.cardList[index].valueDesc
//        this.couponid=this.cardList[index].available
//        console.log(this.cardList[index])
//        console.log(this.couponid)
//        this.allPrice=this.allPrice-this.couponsList
      },
      onExchange(code) {
//        this.coupons.push(coupon);
      },
      insertOrder(){//确认订单
        let _this=this
//        let a=this.$route.query.id.toString()
        let obj={}
        if(this.$route.query){
          let data=this.$route.query
          console.log(data)
          if(data.ref==2){//ref==2是立即购买下单
            obj={
              user_id:localStorage.getItem("userid"),
              address_id:this.address.id,
              goods_id:data.goodid,
              goods_spec_id:data.spec_id,
              stock :data.stock,
              is_group:data.code,
              "tid":data.shoptid
//              goods_spec_id:
//              pay_type:1
            }

          }else {  //购物车下单
            obj={
              id:this.$route.query.id.toString(),
              user_id:localStorage.getItem("userid"),
              address_id:this.address.id,
              pay_type:1
            }
//            if (obj!="")obj.coupon_id=this.couponid
//            console.log(obj)
          }
          if (this.couponid!="")obj.coupon_id=this.couponid

        }
        if(this.address=="")  return this.$toast("请先填写收货地址")
        this.$api.insertOrder(obj).then(res=>{
//          if(res.status==200){
//            localStorage.removeItem("sendId")
//            localStorage.setItem("order",res.order_on)
//            this.$router.replace({
//              path:"/pay",
//              query:{
//                id:this.reverPrice,
//                order:res.order_on
//              }
//            })
//          }
//          if(res.status==200){
            localStorage.removeItem("sendId")
            localStorage.setItem("order",res.order_on)
            if (res.pintuan) {
              this.$toast(res.pintuan.msg)
//              console.log(res.pintuan.tid)
//              _this.codeNull()
              if(res.pintuan.tid){
                localStorage.setItem("shoptid",res.pintuan.tid)
              }
              this.$router.replace({
                path:"/pay",
                query:{
                  id:this.reverPrice,
                  order:res.order_on
                }
              })
            }else {
              this.$router.replace({
                path:"/pay",
                query:{
                  id:this.reverPrice,
                  order:res.order_on
                }
              })
            }

//          }
        })
          .catch(err=>{
          })
      },
      selectCartser(){//订单信息

        let query=this.$route.query
        this.collageNum=query.code
        console.log(query)

        if(query.ref==2){ //ref==2 为立即购买
          this.$api.selectGoodsInfo({
            "user_id":localStorage.getItem("userid"),
            "goods_id":query.goodid,
            "goods_spec_id":query.spec_id,
            "stock":query.stock,
            "is_group":query.code,
            "tid":query.shoptid
          })
            .then(res=>{
              this.listData=res.data
              this.address=res.address
              this.goods=res.data.goods
              this._totalPeice()
            })
        }else {//购物车购买
          let a=query.id.toString()
          this.$api.selectCarts({
            "user_id":localStorage.getItem("userid"),
            "id":a,
//          address_id:"1",
//          pay_type:1
          })
            .then(res=>{
              var data =eval(res.data);
              this.list=res.data
              this.address=res.address
              this._totalPeice()

            })
            .catch(res=>{
            })
        }

      },
      codeNull(code){
//        alert(1)
//        console.log(code)
      },
      selectGoodsCoupon(){
        let query=this.$route.query
        var obj={}
        if(query.ref==2){
          obj={
            user_id:localStorage.getItem("userid"),
            goods_id:query.goodid,
            goods_spec_id:query.spec_id,
            stock:query.stock
          }
        }else {
          obj={
            id:this.$route.query.id.toString(),
            user_id:localStorage.getItem("userid")
          }
        }
        this.$api.selectGoodsCoupon(obj)
          .then(res=>{
            if (!res.data) return
            let _this=this
            let d=new Date()
            res.data.forEach(data=>{
              let dateStart=data.valid_start_time.replace(/\./g, "/");
              let dateEnd=data.valid_end_time.replace(/\./g, "/");


//              console.log(timeStr)
            _this.cardList.push({
               available: data.id,
                condition:"满"+data.full_price+"可用",
//                condition:'无使用门槛\n最多优惠12元',
                reason: '',
                value:data.reduction_price*100,
                name: data.title,
                startAt:new Date(dateStart).getTime()/1000,
                endAt: new Date(dateEnd).getTime()/1000,
                valueDesc: data.reduction_price,
                unitDesc: '元',
              })
            })
            res.nouse.forEach(data=>{
              let nouseStart=data.valid_start_time.replace(/\./g, "/");
              let nouseEnd=data.valid_end_time.replace(/\./g, "/");
              _this.disabledCoupons.push({
                available: data.id,
                condition:"满"+data.full_price+"可用",
//                condition:'无使用门槛\n最多优惠12元',
                reason: '',
                value:data.reduction_price*100,
                name: data.title,
                startAt:new Date(nouseStart).getTime()/1000,
                endAt:new Date(nouseEnd).getTime()/1000,
                valueDesc: data.reduction_price,
                unitDesc: '元',
              })
            })
          })
      },
      _totalPeice () {
        // 每次调用此方法，将初始值为0，遍历价格并累加
        this.allPrice = 0
        this.allCount = 0
        this.list.forEach(item => {
          console.log(item)
          let products = item.goods
          products.forEach(pros => {
            this.allPrice += pros.goods_spec.total_price
           this.allCount+= parseInt(pros.stock)
//            this.allPrice += pros.goods_spec.price*100 * pros.stock
          })
        })
        this.allPrice=this.listData.goods.goods_spec.total_price
        this.allCount=this.listData.goods.goods_spec.stock
      },
    },
    mounted(){
//      this.touch()
      this.selectCartser()
      this.selectGoodsCoupon()
      this.$nextTick(() => {
//        maintain.offsetLeft
//        this.$refs.maintain
//        console.log(this.$refs.maintain.offsetLeft)
//        console.log(this.ceshi.$el.getBoundingClientRect().top)
      })

//      this.insertOrder()
//      beforeRouteLeave (to, from){
////        this.$router.push({path: 'index'})//返回键要返回的路
//      }
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped="">
  *{
    /*overflow-x:hidden;*/
    padding: 0;
    margin: 0;
  }
  .container{
    width:100%;
    height:100%;
  }
  header{
    width: 100%;
    height: 50px;
    background:#ff2500 ;
    position: fixed;
    z-index: 200;
    top: 0;
  }
  header img{
    width: 18px;
    height: 18px;
    padding-left: 10px;
  }
  .headerDiv{
    display: flex;
    align-items: center;
    line-height: 50px;
  }
  .headerDiv p{
    margin: auto;
    font-size: 15px;
  }
.order{
  width: 100%;
  /*height: 100%;*/
  background: #E4E4E4;
  padding-top: 70px;
}
  .orderMessage{
    /*margin-top: 60px;*/
    /*margin-top: 60px;*/
    display: flex;
    align-items: center;
    padding: 10px;
    background: #ffffff;
    /*width: 85%;*/
    margin: 0 auto;
    border-radius: 12px;
    font-size: 14px;
  }
  .orderMessage1{
    display: flex;
    align-items: center;
    padding: 10px;
    background: #ffffff;
    /*width: 85%;*/
    margin: 0 auto;
    border-radius: 12px;
    font-size: 14px;
    justify-content: center;
  }
  .orderIcon{
    background: #F05732;
    width: 25px;
    height: 25px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .orderP{
    padding: 5px 0;
    margin-left: 10px;
  }
  .orderDetail{
    /*width: 90%;*/
    margin:20px auto;
    background: #ffffff;
    border-radius: 10px;
    padding: 10px;
    /*margin: 0 10px;*/
  }
  .orderShopIcon{
    display: flex;
    align-items: center;
  }
  .orderDetailTitle{
   display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
  .orderDetailTitleImg{
    width: 80px;
    height: 80px;
  }
  .orderDetailTitleImg img{
    width: 100%;
    height: 100%;
  }
  .orderDetailMessage{
    font-size: 14px;
    margin-left: 10px;
  }
  .orderDetailMessage p{
   padding-top: 4px;
  }
  .orderDetailQ{
    /*margin-left: 1rem;*/
    float: right;
    color: #f56723;
  }
  .orderDetailDiv{
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
  }
  .orderBottom span{
    padding: 0 2px;
  }
  .orderBottom{
    margin-right: 15px;
  }
  .button{
    padding: 1px 1px;
    padding: 8px 18px;
    border-radius: 3rem;
    border: none;
    background: linear-gradient(to right,#ff6034,#ee0a24);
    color: #FFFFFF;
   font-size: 15px;
  }
  /deep/.van-button{
    right:10px;
  }
  .orderDetailBottom{
    font-size: 14px;
    margin-top: 10px;
    padding-left: 2rem;
    padding-bottom: 10px;
  }
  .productType{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0;
  }
  .productx{
    color: #c9c9c9;
    margin-left: 1rem;
  }
  .productg{

  }
  .productImg{
    background-image: url(../../assets/img/gonext.png);
    background-repeat: no-repeat;
    background-position: 98% center;
    background-size: 7px 15px;
    padding-right: 1rem;
  }
  .orderTotal{
    display: flex;
    justify-content: flex-end;
    padding-right: 1rem;
  }
  /*订单商店logo*/
  .shopIcon{
    display: flex;
    align-items: center;
    font-size: 15px;
  }
  .shopIcon span{
    margin-left: 5px;
    display: flex;
    align-items: center;
  }
  /*底部*/
  /deep/.van-submit-bar__bar{
    padding: 0 20px;
  }
  /*优惠卷*/
  .cardDivList{
    background:#FFFFFF;
    border-radius: 10px;
  }
  .cardDiv{
    display: flex;
    justify-content: space-between;
    padding: 10px 20px;
    font-size: 14px;
  }
  /deep/ .van-coupon-list__exchange-bar{
    display: none;
    background: red;
  }
  /deep/.van-cell{
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/shop/orderPage.vue